// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3NvLL","header":"MessagesList_header__i0TaB","chat":"MessagesList_chat__mNaVl"};